// Request rejects with whatever the server sent as `error`: a string from bhapi, an
// object ({ code, status, message }) from medos, or a thrown Error from a service.

export function errorMessage(error) {
  if (!error) return '';
  if (typeof error === 'string') return error;
  return String(error.message || error.status || error);
}

export function isNotFound(error) {
  return error?.code === 404 || /not found/i.test(errorMessage(error));
}

export default { errorMessage, isNotFound };
